import apiClient from './apiClient';

/**
 * RBAC API Functions
 */

// ===== Roles =====

/**
 * List all roles
 */
export const listRoles = async () => {
  const response = await apiClient.get('/roles');
  return response.data.data || response.data;
};

/**
 * Get a role by ID
 * Note: Currently unused but available for future role detail views
 */
export const getRole = async (roleId) => {
  const response = await apiClient.get(`/roles/${roleId}`);
  return response.data.data || response.data;
};

/**
 * Create a new role
 */
export const createRole = async (roleData) => {
  const response = await apiClient.post('/roles', roleData);
  return response.data;
};

/**
 * Update a role
 */
export const updateRole = async (roleId, updates) => {
  const response = await apiClient.put(`/roles/${roleId}`, updates);
  return response.data;
};

/**
 * Delete a role
 */
export const deleteRole = async (roleId) => {
  const response = await apiClient.delete(`/roles/${roleId}`);
  return response.data;
};

/**
 * Seed default roles (admin only)
 */
export const seedRoles = async () => {
  const response = await apiClient.post('/roles/seed');
  return response.data;
};

/**
 * Get all accounts with a specific role
 */
export const getAccountsByRole = async (roleId) => {
  const response = await apiClient.get(`/roles/${roleId}/accounts`);
  return response.data.data || response.data;
};

// ===== Account Roles =====

/**
 * Get roles assigned to an account
 */
export const getAccountRoles = async (accountId) => {
  const response = await apiClient.get(`/accounts/${accountId}/roles`);
  return response.data.data || response.data;
};

/**
 * Assign a role to an account
 */
export const assignRole = async (accountId, roleId) => {
  const response = await apiClient.post(`/accounts/${accountId}/roles`, { roleId });
  return response.data;
};

/**
 * Unassign a role from an account
 */
export const unassignRole = async (accountId, roleId) => {
  const response = await apiClient.delete(`/accounts/${accountId}/roles/${roleId}`);
  return response.data;
};

// ===== Permissions =====

/**
 * Get current user's permissions and roles
 */
export const getMe = async () => {
  const response = await apiClient.get('/me');
  return response.data.data || response.data;
};

/**
 * Get the permissions catalog (all available permissions)
 * Note: Currently unused but available for future permissions browser UI
 */
export const getPermissionsCatalog = async () => {
  const response = await apiClient.get('/permissions');
  return response.data;
};
